import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ReturnLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", d: "m20 10 .354.354.353-.354-.353-.354zM3.5 18a.5.5 0 0 0 1 0zm11.854-2.646 5-5-.708-.708-5 5zm5-5.708-5-5-.708.708 5 5zM20 9.5H10v1h10zM3.5 16v2h1v-2zM10 9.5A6.5 6.5 0 0 0 3.5 16h1a5.5 5.5 0 0 1 5.5-5.5z" }) }) });
}
const ReturnLight = forwardRef(_ReturnLight);
export { ReturnLight };
